import { Component, Inject } from '@angular/core';
import { GoDialogRef } from '@go-modules/services/go-dialog-ref/go-dialog-ref';
import { GO_MODAL_DATA } from '@go-modules/services/go-modal/go-modal.tokens';

export interface InstructionDataInterface {
	text: string;
	type: string;
	media: any;
}

@Component({
	selector: 'instructions-preview',
	templateUrl: './instructions-preview-dialog.component.html',
	styleUrls: ['./instructions-preview-dialog.component.scss'],
	standalone: false
})
export class InstructionsPreviewDialogComponent {
	public instruction: InstructionDataInterface;

	constructor (
		public dialogRef: GoDialogRef,
		@Inject(GO_MODAL_DATA) public data: {
			instruction: InstructionDataInterface;
		}
	) {}

	public close () {
		this.dialogRef.close();
	}
}
